const CustomTreeItem = ({ item, isOpened, openedItem, openedList, active, handleSetType, handleClickItem, checkStatus }) => {
    const getItem = () => {
        return (<div
            className={`tree__item__collapse ${openedList.includes(item.key) ? 'tree__item__collapse-open' : ''}`}
            onClick={item?.children?.length > 0 ? handleClickItem(item.key) : handleSetType(item)}
        >
            <div className='tree__item__wrapper'>
                <div
                    className={`tree__square ${checkStatus(item)}`}
                    onClick={handleSetType(item)}
                >
                    <img src='/Checked.svg' alt='arrow' />
                    <div className="tree_squre_part_choose"></div>
                </div>
                <p>{item.title}</p>
                {item?.children?.length > 0 ? <img src='/BlackArrow.svg' className='tree__parent__arrow' alt='arrow' /> : null}
            </div>
            {item?.children?.length > 0 ? <div className='tree__childrens '>
                {item.children.map((child) => <CustomTreeItem
                    item={child}
                    openedList={openedList}
                    active={active}
                    handleSetType={handleSetType}
                    handleClickItem={handleClickItem}
                    checkStatus={checkStatus}
                />)}
            </div> : null}
        </div>)
    }

    return <div className="tree__item">
        {getItem()}
    </div>
}

export default CustomTreeItem